/* global fbq */
import store from '@/store'
import productConn from '@/connection/productsv2'
import axios from 'axios'
import User from '@/connection/user'
import _ from 'lodash'

export default {
  async addToCart (productId, productViewId, observation, options) {
    console.log('productDB', productId, productViewId)
    
    
    let productDB = await productConn.getProductById(productId)
    console.log('productDB', productDB)
    let inCart = await this.isInCart(productId, productViewId)



    if (inCart === false || store.state.company.company_type === 'RESTAURANT') {
      let productViewFilter = productDB.product_views.filter(pv => pv.id === productViewId)
      if (productDB && productViewFilter.length) {
        let productView = productViewFilter[0]
        let productCart = new this.ProductCartObj()
        // by now accept duplicated product only if is RESTAURANT
        if (store.state.company.company_type === 'RESTAURANT') {
          productCart.productCartId = new Date().getTime()
        }
        productCart.id = productDB.id
        productCart.qtd = 1
        productCart.productViewId = productView.id
        productCart.EAN = productView.ean
        productCart.name = productView.name
        productCart.stockQtd = productView.stock_quantity
        productCart.observation = observation
        if (productView.photos && productView.photos.length) {
          productCart.image = productView.photos[0].id
        } else {
          if (productDB.photos.length && productDB.photos[0].id) {
            productCart.image = productDB.photos[0].id
          } else {
            productCart.image = null
          }
        }
        // product options for food
        if (options) {
          productCart.options = options
        }
        
        ///////////
        this.setProductRightPrice(productCart, productView, productDB)
        ///////////

        store.state.cart.products.push(productCart)
        // cart.total = cart.total + productCart.price
        // cart.totalDiscount = cart.totalDiscount + productCart.discount
        await this.reCalculateCart()
        
        if (store.state.facebookPixel) {
          fbq('track', 'AddToCart', {
            content_ids: [productCart.id, productCart.EAN],
            content_name: productCart.name,
            currency: 'BRL',
            value: productCart.price
          })
        }
        return true
      } else {
        console.log('product not found')
        return false
      }
    } else {
      console.log('on cart')
      return false
    }
  },

  // this method will determine all prices with or without wasteless, atacarejo, product views and discounts
  setProductRightPrice (productCart, productView, productDB) {
    productCart.originalPrice = productView.price
    if (!productDB.expires_at) {
      if (productView.promotional_price) {
        productCart.price = Number(productView.promotional_price)
        productCart.discount = Number(productView.price) - Number(productView.promotional_price)
      } else {
        productCart.price = Number(productView.price)
        productCart.discount = 0
      }
      if (productView.promotional_conditionals && productView.promotional_conditionals.length) {
        productCart.promotional_conditionals = productView.promotional_conditionals
        productCart.promotional_conditionals.sort((a, b) => {
          return b.number_of_products_to_promo - a.number_of_products_to_promo
        })
      }
    } else {
      productCart.wasteless = true
      productCart.price = this.getWastelessRightPrice(productDB)
      productCart.discount = Number(productCart.originalPrice) - Number(productCart.price)
    }

    // add plus price for food options
    if (productCart.options) {
      productCart.options.forEach((o) => {
        o.choices.forEach((c) => {
          if (c.price) {
            productCart.price += (c.price * c.quantity)
          }
        })
      })
    }
  },

  getWastelessRightPrice (product) {
    let nowTime = new Date().getTime()
    let expire = product.expires_at
    let days = (expire - nowTime) / (1000 * 60 * 60 * 24)
    let price = product.product_views[0].price
    let discount_list = _.clone(product.wasteless_code.discount_list)
    discount_list.sort((a, b) => {
      return a.days_left - b.days_left
    })
    for (let x=0; x<discount_list.length; x++){
      if (discount_list[x].days_left >= days ){
        price = product.product_views[0].price - ((product.product_views[0].price * discount_list[x].discount) / 100)
        break
      }
    } 
    return price
  },

  async isInCart (productId, productViewId, productCartId) {
    let products = store.state.cart.products
    let productsFilter = []
    
    if (productCartId) {
      productsFilter = products.filter(p => p.productCartId === productCartId)
    } else {
      productsFilter = products.filter(p => p.id === productId && p.productViewId === productViewId)
    }
    
    if (productsFilter.length) {
      return productsFilter[0]
    } else {
      return false
    }
  },

  async removeToCart (productId, productViewId, productCartId) {
    let product = await this.isInCart(productId, productViewId)
    if (product !== false) {
      console.log('remove', productId, productViewId)
      if (productCartId) {
        store.state.cart.products = store.state.cart.products.filter(p => p.productCartId !== productCartId)
      } else {
        store.state.cart.products = store.state.cart.products.filter(p => p.id !== productId && p.productViewId !== productViewId)
      }
      this.reCalculateCart()
      console.log('not cart')
      return true
    } else {
      return false 
    }
  },

  async plusQtd (productId, productViewId, productCartId) {
    let did = false
    let reason = ''
    store.state.cart.products.forEach((p) => {
      if ((productCartId && productCartId === p.productCartId) || (!productCartId && p.id === productId && p.productViewId === productViewId)) {
        if (p.qtd +1 > p.stockQtd){
          did = false
          reason = 'Quantidade de estoque máxima para este produto atingida.'
        } else {
          p.qtd = p.qtd + 1
          did = true
        }
      }
    })
    if (did) {
      await this.reCalculateCart()
    }
    return [did, reason]
  },

  async reCalculateCart () {
    let cart = _.clone(store.state.cart)
    cart.total = 0
    cart.totalDiscount = 0
    cart.products.forEach(async (pc) => {
      let p = await productConn.getProductById(pc.id)
      let pvIdx = 0
      for (let x=0; x<p.product_views.length; x++){
        if (p.product_views[x].id === pc.productViewId){
          pvIdx = x
          break;
        }
      }
      let atacarejo = p.product_views[pvIdx].promotional_conditionals
      let promotional = p.product_views[pvIdx].promotional_price
      let calcDiscount = 0
      if (!pc.wasteless) {
        // normal discount condition
        pc.price = p.product_views[pvIdx].price
        // atacarejo condition
        if (atacarejo) {
          for (let x=0; x < atacarejo.length; x++) {
            if (atacarejo[x].number_of_products_to_promo <= pc.qtd) {
              pc.price = atacarejo[x].promotional_conditional_price
              calcDiscount = atacarejo[x].promotional_conditional_price
              break;
            }
          }
        }
        // promotional price condition
        if (promotional && promotional < pc.price) {
          pc.price = promotional
          calcDiscount = promotional
        }
      } else {
        pc.price = this.getWastelessRightPrice(p)
        calcDiscount = pc.price
      }
      // add plus price for food options
      if (pc.options) {
        pc.options.forEach((o) => {
          o.choices.forEach((c) => {
            if (c.price) {
              pc.price += (c.price * c.quantity)
            }
          })
        })
      }
      cart.total = cart.total + (pc.price * pc.qtd)
      cart.totalDiscount = cart.totalDiscount + ((p.product_views[pvIdx].price - calcDiscount)  * pc.qtd)
    })
    // recalculate cupom
    if (store.state.cupomObject) {
      if (store.state.cupomObject.discount_type === 'PERCENTAGE') {
        cart.cupomDiscount = (Number(store.state.cupomObject.discount_value) * store.state.cart.total) / 100
      } else {
        cart.cupomDiscount = Number(store.state.cupomObject.discount_value)
      }
    } else {
      cart.cupomDiscount = 0
      store.state.cupomCode = null
    }
    //////////////////////////
    store.state.cart = cart
    return true
  },

  async minusQtd (productId, productViewId, productCartId) {
    let did = false
    let remove = false
    let cart = store.state.cart
    cart.products.forEach((p) => {
      if ((productCartId && productCartId === p.productCartId && p.qtd > 1) || (!productCartId && p.id === productId && p.productViewId === productViewId && p.qtd > 1)) {
        p.qtd = p.qtd - 1
        did = true
      } else if ((productCartId && productCartId === p.productCartId && p.qtd === 1) || (!productCartId && p.id === productId && p.productViewId === productViewId && p.qtd === 1)) {
        remove = true
      }
    })
    if (remove === true) {
      store.state.cart = cart
      return this.removeToCart(productId, productViewId, productCartId)
    } else {
      store.state.cart = cart
      this.reCalculateCart()
      return did
    }
  },

  getQtd (productId, productViewId, productCartId) {
    let cart = store.state.cart
    let cartProduct = []
    if (productCartId) {
      cartProduct = cart.products.filter(p => p.productCartId === productCartId)
    } else {
      cartProduct = cart.products.filter(p => p.id === productId && p.productViewId === productViewId)
    }
    if (cartProduct.length) {
      return cartProduct[0].qtd
    } else {
      return 0
    }
  },

  getCartItensToDelivery () {
    let cartItens = store.state.cart.products
    return cartItens.map((p) => {
      return {
        id: p.id,
        product_view_id: p.productViewId,
        quantity: p.qtd
      }
    })
  },

  getTotalToDelivery () {
    let cart = store.state.cart
    return cart.total
  },

  async checkout (cvv, idAddress, idCard, willDelivery, scheduleInfo, scheduleTime, voucherCode, voucherDiscount) {
    try {
      let cart = store.state.cart
      let sessionToken = await User.getSessionToken('session_token')
      if (sessionToken) { 
        let header = { 'Authorization': sessionToken}
        let cktObject = {
          cart_product_list : this.getCartProductsToCheckoutV2(cart.products),
          cvv: cvv,
          delivery_address_id: idAddress,
          payment_address_id: idAddress,
          card_id: idCard,
          payment_type: 1,
          installment_number: 1,
          stage: store.state.company.stage,
          will_delivery: willDelivery,
          total_price: cart.total,
          delivery_fee: cart.deliveryTax ? Number(cart.deliveryTax) : 0,
          sub_company_id: store.state.choicedCompanyId,
        }
        if (scheduleInfo) {
          cktObject.delivery_schedule_info = scheduleInfo
          cktObject.delivery_schedule_time = scheduleTime
        }
        if (voucherCode) {
          cktObject.voucher_code = voucherCode
          cktObject.total_price = cktObject.total_price - voucherDiscount
          if (cktObject.total_price < 0){
            cktObject.total_price = 0
          }
        }

        if (store.getters.getChoicedCompany.service_fee) {
          cktObject.service_fee = store.getters.getChoicedCompany.service_fee
        }

        let returnCheckout = await axios.post(store.getters.getCheckoutApi + '/checkout', cktObject, { headers: header })
        if (store.state.facebookPixel) {
          fbq('track', 'Purchase', {
            currency: 'BRL',
            value: cart.total,
            num_items: cart.products.length,
            content_ids: cart.products.map(p => p.EAN),
            content_type: 'product',
            contents: cart.products.map((p) => {
              return new this.ProductFB(p.EAN, p.qtd, p.price, p.name)
            }),
          })
        }
        if (returnCheckout.data) {
          return returnCheckout.data
        } else {
          return {error: true, msg: 'Erro ao finalizar compra'}
        }
      } else {
        return {error: true, code: 400, msg:'Sessão Expirada.'}
      }
    } catch (e) {
      let error = {e}
      console.log(error, e)
      let msg = 'Erro ao finalizar compra'
      if (error.e.msg) {
        msg = error.e.msg
        console.log(msg = error.e.msg)
      }
      return {error: true, obj:error, msg: msg}
    }
  },

  getCartProductsToCheckoutV2 (cartProducts) {
    let nCartProducts = []
    cartProducts.forEach((p) => {
      let np = {  
        'id': p.id,
        'product_view_id': p.productViewId,
        'quantity': p.qtd,
        'price': p.price,
        'discount': p.discount || 0
      }
      if (p.observation) {
        np.observation = p.observation
      }
      if (p.options) {
        np.options = p.options
      }
      nCartProducts.push(np)
    })
    return nCartProducts
  },

  ProductCartObj () {
    this.wasteless = false
    this.productCartId = null
    this.id = null
    this.productViewId = null
    this.qtd = 0
    this.name = null
    this.EAN = null
    this.image = null
    this.price = 0
    this.discount= 0 
    this.originalPrice = 0
    this.stockQtd = 0
    this.observation = null
    return this
  },

  ProductFB (id, quantity, item_price, name) {
    this.id = id,
    this.quantity = quantity,
    this.item_price = item_price
    this.name = name
    return this
  }
}